module.exports = __webpack_public_path__ + "static/img/全民营销-4.cf662f46.png";